import CustomerTargetOrderDetail from '../../customer/TargetOrder/CustomerTargetOrderDetail'

const SalesmanTargetOrderDetail = CustomerTargetOrderDetail

export default SalesmanTargetOrderDetail
